export function AppFooter() {
  return (
    <footer class="app-footer">
      <p class="app-footer__copyright">
        © <time dateTime="2026">2026</time> Vamshi Krishna Madhavan. All rights reserved.
      </p>
      <p class="app-footer__signature">FluxRTC · Private by design</p>
    </footer>
  );
}
